import Bugsnag from "@bugsnag/js";
import { API_ROUTES, APPLICATION_ROUTES, COOKIES } from "../constants";
import Cookies from "../utilities/cookies";
import { APIError } from "../utilities/errors";
import { getMid } from "../utilities/mid";

const ACCESS_DENIED_REDIRECT_EXCLUDED_PATHS = [
  API_ROUTES.LIBRARY.SECURE_VIDEO_URL,
];

const isExcludedFromAccessDeniedRedirect = (path) => {
  if (!path) return false;
  return ACCESS_DENIED_REDIRECT_EXCLUDED_PATHS.some((excluded) =>
    path.startsWith(excluded)
  );
};

const redirectToAccessDenied = (ip) => {
  if (typeof window === "undefined") return;
  if (window.location.pathname === APPLICATION_ROUTES.ACCESS_DENIED) return;
  const target = ip
    ? `${APPLICATION_ROUTES.ACCESS_DENIED}?ip=${encodeURIComponent(ip)}`
    : APPLICATION_ROUTES.ACCESS_DENIED;
  window.location.replace(target);
};

const API = class {
  constructor() {
    // eslint-disable-next-line no-undef
    this.url = process.env.REACT_APP_API_URL;
  }

  async request(path, { body, headers, method = "GET" } = {}) {
    const authorization = Cookies.get({ name: COOKIES.AUTHORIZATION });
    const mid = getMid();

    const requestHeaders = {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: authorization,
    };

    if (mid) {
      requestHeaders["X-MID"] = mid;
    }

    const options = {
      headers: requestHeaders,
      method,
    };

    // Check if the body is a FormData instance or other binary data
    if (body instanceof FormData) {
      options.body = body;
      // Let the browser set the `Content-Type` for FormData
      delete options.headers["Content-Type"];
    } else if (body) {
      options.body = JSON.stringify(body);
      options.headers["Content-Type"] = "application/json";
    }

    // Merge additional headers
    if (headers) {
      options.headers = { ...options.headers, ...headers };
    }

    const promise = fetch(`${this.url}${path}`, options);

    promise
      .then((response) => {
        if (
          response.status === 403 &&
          !isExcludedFromAccessDeniedRedirect(path)
        ) {
          response
            .clone()
            .json()
            .then((body) => {
              const ip = body?.data?.ip_address;
              if (ip) {
                redirectToAccessDenied(ip);
              } else {
                const apiError = new APIError({ response: response, body: body });
                Bugsnag.notify(apiError);
              }
            })
            .catch((error) => {
              const apiError = new APIError({
                response: response,
                body: error,
              });
              Bugsnag.notify(apiError);
            });
          return;
        }
        if (response.status >= 300 && response.status != 422) {
          response
            .json()
            .then((body) => {
              const apiError = new APIError({ response: response, body: body });
              Bugsnag.notify(apiError);
              return { response: response, body: body };
            })
            .catch((error) => {
              const apiError = new APIError({
                response: response,
                body: error,
              });
              Bugsnag.notify(apiError);
            });
        }
      })
      .catch(console.log);

    return promise;
  }
};

export default API;
